// extracted by mini-css-extract-plugin
module.exports = {"SearchComponentHolder":"SearchFactur_SearchComponentHolder__2lrxM","SearchInput":"SearchFactur_SearchInput__23tWT"};